import { render, staticRenderFns } from "./DropdownMin.vue?vue&type=template&id=1af56c21&"
import script from "./DropdownMin.vue?vue&type=script&lang=js&"
export * from "./DropdownMin.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMin.vue?vue&type=style&index=0&id=1af56c21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports